import { memo } from "react";

export const CoverageDetails = memo(function CoverageDetails() {
  return null;
});
